/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestBuildMaxCommandTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_BUILD_MAX_COMMAND_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class NewAutoTestBuildMaxCommandTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestBuildMaxCommandTimeSettingParser.decode(input).map(res => new NewAutoTestBuildMaxCommandTimeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestBuildMaxCommandTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestBuildMaxCommandTimeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestBuildMaxCommandTimeSettingParser.schema();
    }
}
